export default __webpack_public_path__ + "static/media/cont5.30be3876.jpg";